import { Control } from './styled'

const ControlButton = ({
  theme = 'base',
  onClick,
  children,
  className,
  active,
  disabled = false,
}) => (
  <Control
    type="button"
    theme={theme}
    onClick={onClick}
    active={active}
    className={className}
    disabled={disabled}
  >
    {children}
  </Control>
)

export default ControlButton
